// src/hooks/useProductPageContent.js
import { useState } from "react";
import { getStoreInformation, GetShopBanner, GetTopBanner } from "../services/companyService";

const useStoreInformation = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [error, setError] = useState("");
  const [data, setData] = useState(null);

  const fetchStoreInformation = async (storeId) => {
    setStatus("loading");
    setError("");

    try {
      const response = await getStoreInformation(storeId);

      if (response?.status !== "Error") {
        // console.log("fetch category data",response.data)
        setData(response.data ?? response); // depending on API shape
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };


  const fetchShopforBanner = async (req) => {
    setStatus("loading");
    setError("");

    try {
      const response = await GetShopBanner(req);

      if (response?.status !== "Error") {
        // console.log("fetch category data",response.data)
        setData(response.data ?? response); // depending on API shape
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };


  const fetchTopBanner = async (req) => {
    setStatus("loading");
    setError("");

    try {
      const response = await GetTopBanner(req);

      if (response?.status !== "Error") {
        // console.log("fetch category data",response.data)
        setData(response.data ?? response); // depending on API shape
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const resetStatus = () => {
    setStatus("idle");
    setError("");
  };

  return {
    fetchStoreInformation,
    fetchShopforBanner,
    fetchTopBanner,
    data,
    status,
    error,
    resetStatus,
  };
};

export default useStoreInformation;
